import React from 'react';

import { Skeleton } from '../Skeleton';

/**
 * Скелетон блока лайков для поста
 */
export const PostLikesSkeleton = () => <Skeleton height={130} borderRadius={'8px'} />;
